import { render, staticRenderFns } from "./SettingsDiagnosisView.vue?vue&type=template&id=658f839f&scoped=true&"
import script from "./SettingsDiagnosisView.vue?vue&type=script&lang=js&"
export * from "./SettingsDiagnosisView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsDiagnosisView.vue?vue&type=style&index=0&id=658f839f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658f839f",
  null
  
)

export default component.exports